import Modal from '@/components/modals/Modal';
import YouTubeVideo from '@/components/YouTubeVideo';
import { FC } from 'react';

interface HowFrontWorksVideoModalProps {
  onClose: () => void;
}

const HowFrontWorksVideoModal: FC<HowFrontWorksVideoModalProps> = ({ onClose }) => (
  <Modal name="Why Front Video" onClose={onClose}>
    <YouTubeVideo
      videoId="5BI7WwNBGj4"
      coverSrc="/staticwebassets/pages/product-explainer/hero-video-cover.jpg"
      showPlayButton={false}
      autoplay
    />
  </Modal>
);

export default HowFrontWorksVideoModal;
